import React from 'react';
import { AccordionBodyItemView } from 'component/Accordion';

export const ReportZoneView = (props) => {
  const { formData } = props;
  const fileZone = formData?.info?.general?.file_zone ?? formData?.file_zone ?? '';
  return (
    <AccordionBodyItemView
      accordionSubId={null}
      titleUA="Зона звіту"
      titleEN="Report zone"
      children={fileZone}
    />
  );
};
